import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from 'src/ui/library/Button';
import intl from 'react-intl-universal';
import FormGroup from '@material-ui/core/FormGroup';
import Autocomplete from 'src/ui/library/Autocomplete';
import AttachFile from '@material-ui/icons/AttachFile';
import Close from '@material-ui/icons/Close';

import PriorityHigh from '@material-ui/icons/PriorityHigh';
import RichTextEditor from 'src/ui/library/RichTextEditor';
import { TITLES } from 'src/constants/constants';
import Hidden from '@material-ui/core/Hidden';

import UploadView from 'src/ui/library/Upload/UploadViewContainer';
import UploadPad from 'src/ui/library/Upload/UploadPad';
import { ATTACHMENT_TYPES } from 'src/constants/constants';
import { getFileTypes } from 'src/helpers/upload';
import { MESSAGEDETAIL_TYPES } from 'src/constants/constants';
import DeleteIcon from '@material-ui/icons/Delete';
import { ConfirmDialog } from 'src/ui/library/Dialog';
import { fnIsDefaultOldView } from 'src/helpers/commonFunctions';

export default function ComposeMsgPres({
  detailType,
  initialValues,
  isMobile,
  isDraftView,
  isReplyView,
  isTablet,
  isForwardView,
  isSendable,
  onCancel,
  onSubmit,
  onDraftSave,
  onFieldUpdate,
  onRequestCases,
  onRequestAccounts,
  attachSelected,
  toggleAttachment,
  attachFiles,
  attachments,
  priority,
  deleteAttachment,
  downloadAttachment,
  rejected,
  removeUnsupportedFile,
  isBeingSent,
  isDraftClicked,
  caseInfo,
  to,
  cc,
  caseDetails,
  deleteDraft,
  caseContactInfo,
  isDefaultOldView,
  casePillInfo,
  subject,
  body,
}) {
  const [openDilaoge, setOpenDialoge] = useState(false);
  const detailClass = detailType.toLowerCase();
  const attachClass = classNames('icon md', { selected: attachSelected });
  const messagingActionsClass = classNames('messaging-actions', { 'messaging-actions-mobile': isMobile || isTablet });
  const messagingComposeClasses = classNames({ 'messaging-compose': true, detailClass, mobile: isMobile });
  const messagingDetailClasses = classNames({ 'messaging-detail': true, composemsg: true, padBtm80: isMobile });

  const attachmentMenu = [
    {
      key: `${intl.get('messaging.attachmentMenu.download')}`,
      icon: `${intl.get('messaging.attachmentMenu.cloudDownload')}`,
      text: `${intl.get('messaging.attachmentMenu.download')}`,
      handler: downloadAttachment,
    },
    {
      key: `${intl.get('messaging.attachmentMenu.delete')}`,
      icon: `${intl.get('messaging.attachmentMenu.delete')}`,
      text: `${intl.get('messaging.attachmentMenu.delete')}`,
      handler: deleteAttachment,
    },
  ];

  const recipientEmails = [...to.map(val => val.email), ...cc.map(val => val.email)];

  const deleteMessage = () => {
    setOpenDialoge(true);
  };

  const hideConfirm = () => {
    setOpenDialoge(false);
  };

  const getMessageBody = () => {
    let messageBody = '';
    if (isReplyView || isDraftView || isForwardView) messageBody = (initialValues && initialValues.body) || '';
    else messageBody = body || '';
    return messageBody.trim().length > 0 ? (messageBody.startsWith('<br') ? messageBody : '<br /><br />' + messageBody) : '';
  };

  return (
    <React.Fragment>
      {openDilaoge && (
        <ConfirmDialog
          open
          title={intl.get('messaging.deleteDraft.confirmModal.title')}
          cancelText={intl.get('messaging.deleteDraft.confirmModal.cancel')}
          confirmText={intl.get('messaging.deleteDraft.confirmModal.confirm')}
          onCancel={hideConfirm}
          onConfirm={() => {
            setOpenDialoge(false);
            deleteDraft();
          }}>
          <span>{intl.get('messaging.deleteDraft.confirmModal.text')}</span>
        </ConfirmDialog>
      )}
      {fnIsDefaultOldView() ? null : (
        <div className="action-message-footer-btns">
          <div className={messagingActionsClass}>
            <div className="actions-button-wrapper">
              <div className={'actions-savedraft-wrapper'}>
                {isDraftView && (
                  <button className="ey-link" onClick={deleteMessage}>
                    <DeleteIcon />
                    <span className="action-item-text" style={{ position: 'relative', bottom: '5px' }}>
                      {intl.get('messaging.deleteDraft.deletemessage')}
                    </span>
                  </button>
                )}
                {isSendable && !isDraftClicked && (
                  <button onClick={onDraftSave.bind(this, false)} className="ey-link">
                    {intl.get('messaging.compose.saveasdraft')}
                  </button>
                )}
              </div>
              <Hidden xsDown>
                <Button styleType="secondary" onClick={onCancel} className="action-button">
                  {intl.get('messaging.compose.cancel')}
                </Button>
              </Hidden>
              <Button className="action-button" disabled={!isSendable || isBeingSent} onClick={isSendable ? onSubmit : null}>
                {intl.get('messaging.compose.send')}
              </Button>
            </div>
          </div>
        </div>
      )}

      <div className={messagingDetailClasses}>
        {isMobile && (
          <header className={'compose-mobile-header'}>
            <div className="compose-mobile-wrapper">
              <span className="mobile-title">{TITLES[detailType]}</span>
              <Close className="mobile-close" onClick={onCancel} />
            </div>
          </header>
        )}
        <div className={messagingComposeClasses}>
          <form className={'compose-form'}>
            <FormGroup className={'compose-formgroup'} row>
              <div className={fnIsDefaultOldView() ? 'compose-input-wrapper' : 'compose-input-wrapper input-asterisk-required'}>
                <Autocomplete
                  autoFocus={detailType === MESSAGEDETAIL_TYPES.FORWARD || detailType === MESSAGEDETAIL_TYPES.COMPOSE ? true : false}
                  label={`${intl.get('messaging.compose.to')}:`}
                  required={fnIsDefaultOldView() ? false : true}
                  styleType="email"
                  defaultValue={(initialValues && initialValues.to) || null}
                  value={to || null}
                  multi={true}
                  onFilter={(row, val) => {
                    const { email, name } = row.data;
                    if (recipientEmails.length && recipientEmails.includes(email)) {
                      return false;
                    }
                    const arr = [email, name];
                    return arr.some(item => item && val && item.toLowerCase().includes(val.toLowerCase()));
                  }}
                  onChange={val => onFieldUpdate('to', val)}
                  loadOptions={onRequestAccounts}
                  getOptionValue={row => row}
                />
              </div>
              {// document upload option through secure message has been disabled here until further notice
              false && (
                <div className={'compose-formgroup-icon'}>
                  <nav className="nav-bar">
                    <span tabIndex={0} role="button" aria-label="Attach file">
                      <AttachFile className={attachClass} onClick={toggleAttachment} />
                    </span>
                  </nav>
                </div>
              )}
            </FormGroup>
            <FormGroup className={'compose-formgroup'} row>
              <div className={'compose-input-wrapper'}>
                <Autocomplete
                  label={`${intl.get('messaging.compose.cc')}:`}
                  styleType="email"
                  multi={true}
                  defaultValue={(isReplyView || isDraftView) && initialValues ? initialValues.cc : null}
                  value={cc || null}
                  removeAsterisk={true}
                  required={false}
                  onFilter={(row, val) => {
                    const { email, name } = row.data;
                    if (recipientEmails.length && recipientEmails.includes(email)) {
                      return false;
                    }
                    const arr = [email, name];
                    return arr.some(item => item && val && item.toLowerCase().includes(val.toLowerCase()));
                  }}
                  onChange={val => onFieldUpdate('cc', val)}
                  loadOptions={onRequestAccounts}
                  getOptionValue={row => row}
                />
              </div>
              <div className={'compose-formgroup-icon'} />
            </FormGroup>

            <FormGroup className={'compose-formgroup'} row>
              <div className={'compose-input-wrapper'}>
                <label className={'compose-formlabel'}>{intl.get('messaging.compose.subject')}:</label>
                {!fnIsDefaultOldView() ? <span className="mandatory-field">*</span> : null}
                <input
                  id="cmpMsgSubject"
                  type="text"
                  className={'compose-forminput'}
                  defaultValue={isReplyView || isDraftView || isForwardView ? initialValues && initialValues.subject : null}
                  value={subject || ''}
                  onChange={e => onFieldUpdate('subject', e.target.value)}
                />
              </div>

              <div className={'high-priority'}>{intl.get('messaging.compose.highPriority')}</div>
              <PriorityHigh
                aria-hidden={false}
                aria-label={intl.get('messaging.compose.highPriority')}
                tabIndex={0}
                className={'compose-formgroup-icon priority-high' + (priority ? ' active' : '')}
                onClick={e => onFieldUpdate('priority', !priority)}
              />
            </FormGroup>

            <FormGroup className={'compose-formgroup'} row>
              <div className={'compose-input-wrapper'}>
                {caseInfo ? (
                  <Fragment>
                    <label className={'compose-formlabel'}>{intl.get('messaging.compose.case')}:</label>
                    <div className="compose-message-caseid">
                      <span>{`${caseInfo.caseName}, ${caseInfo.employee}, ${caseInfo.engagement}`}</span>
                    </div>
                  </Fragment>
                ) : (
                  <div className={initialValues && initialValues.caseId ? 'compose-message-caseid' : ''}>
                    <Autocomplete
                      label={`${intl.get('messaging.compose.case')}:`}
                      styleType="emailCases"
                      multi={false}
                      removeAsterisk={true}
                      defaultValue={casePillInfo ? casePillInfo : caseDetails}
                      onFilter={(row, val) => {
                        const { engagement, caseName } = row.data;
                        const arr = [engagement, caseName];
                        return arr.some(item => item && val && item.toLowerCase().includes(val.toLowerCase()));
                      }}
                      onChange={val => onFieldUpdate('caseId', val ? val.caseId : '')}
                      loadOptions={onRequestCases}
                      getOptionValue={row => row}
                    />
                  </div>
                )}
              </div>
              <div className={'compose-formgroup-icon'} />
            </FormGroup>

            <FormGroup className={classNames('compose-formgroup', 'msgbody')} row>
              {attachSelected && (
                <UploadPad
                  dropHandler={attachFiles}
                  acceptedFileTypes={getFileTypes(ATTACHMENT_TYPES).join()}
                  closeHandler={toggleAttachment}
                  maxSize="5000000"
                />
              )}

              <UploadView
                attachments={attachments}
                menu={attachmentMenu}
                rejected={rejected}
                removeUnsupportedFile={removeUnsupportedFile}
              />
              <RichTextEditor
                className={'compose-formgroup-textwrapper'}
                styleType={'messaging'}
                autoFocus={detailType === MESSAGEDETAIL_TYPES.REPLY || detailType === MESSAGEDETAIL_TYPES.REPLY_TO_ALL ? true : false}
                defaultValue={getMessageBody()}
                onTextChange={val => onFieldUpdate('body', val)}
              />
            </FormGroup>
          </form>
        </div>

        {fnIsDefaultOldView() ? (
          <div className={messagingActionsClass}>
            <div className="actions-button-wrapper">
              <Hidden xsDown>
                <Button styleType="secondary" onClick={onCancel} className="action-button">
                  {intl.get('messaging.compose.cancel')}
                </Button>
              </Hidden>
              <Button className="action-button" disabled={!isSendable || isBeingSent} onClick={isSendable ? onSubmit : null}>
                {intl.get('messaging.compose.send')}
              </Button>
            </div>
            <div className={'actions-savedraft-wrapper'}>
              {isSendable && !isDraftClicked && (
                <button onClick={onDraftSave.bind(this, false)} className="ey-link">
                  {intl.get('messaging.compose.saveasdraft')}
                </button>
              )}
              {isDraftView && (
                <button className="ey-link" onClick={deleteMessage}>
                  <DeleteIcon />
                  <span className="action-item-text" style={{ position: 'relative', bottom: '5px' }}>
                    {intl.get('messaging.deleteDraft.deletemessage')}
                  </span>
                </button>
              )}
            </div>
          </div>
        ) : null}
      </div>
    </React.Fragment>
  );
}

ComposeMsgPres.propTypes = {
  initialValues: PropTypes.object,
  detailType: PropTypes.string.isRequired,
  isDraftView: PropTypes.bool.isRequired,
  isReplyView: PropTypes.bool.isRequired,
  isForwardView: PropTypes.bool.isRequired,
  isSendable: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onDraftSave: PropTypes.func.isRequired,
  onFieldUpdate: PropTypes.func.isRequired,
  onRequestCases: PropTypes.func.isRequired,
  onRequestAccounts: PropTypes.func.isRequired,
  attachSelected: PropTypes.bool.isRequired,
  toggleAttachment: PropTypes.func.isRequired,
  attachFiles: PropTypes.func.isRequired,
  attachments: PropTypes.array.isRequired,
  isDraftClicked: PropTypes.bool.isRequired,
};
